module.exports = __webpack_public_path__ + "static/media/gift01_en.c20d37b4.png";